export default {
  apiKey: "AIzaSyBtcS1NtwOJI517-c2wjpVwn9J12ayrLAk",
  authDomain: "telemedicina-1bfb6.firebaseapp.com",
  projectId: "telemedicina-1bfb6",
  storageBucket: "telemedicina-1bfb6.appspot.com",
  messagingSenderId: "174787701434",
  appId: "1:174787701434:web:e30f1a83414b30c424b083",
  measurementId: "G-8SST1JM6W7"
};
